module.exports = __webpack_public_path__ + "media/3_12.3db95255.wav";